import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ChangeSet, OrderHistory} from "./order-history.model";
import {OrderStatusEnum} from "../../../store/state/order.state";

@Component({
    selector: 'order-history',
    templateUrl: './order-history.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderHistoryComponent {

	@Input() orderHistory: OrderHistory;
	@Input() showDailyRate: boolean = false;
	@Input() includeOffsiteDays: boolean = false;
	@Input() billingInfoVisible: boolean;

	isLead(changeSet: ChangeSet): boolean {
		return changeSet.order.status == OrderStatusEnum.LEAD;
	}
}
